<template>
  <div class="tree-people">
    <div class="search" v-if="isSearch">
      <el-input
        class="gray white"
        placeholder="搜索部门名和员工名"
        prefix-icon="el-icon-search"
        v-model="filterText"
        clearable
      >
      </el-input>
    </div>
    <el-tree
      ref="tree"
      node-key="id"
      :filter-node-method="filterNode"
      :data="companyList"
      :props="defaultProps"
      show-checkbox
      check-strictly
      :highlight-current="true"
      :default-expanded-keys="[id]"
      :current-node-key="id"
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
      @check-change="handleNodeCheck"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span v-if="data.children" class="iconfont" style="margin-right: 16px">
          <img :src="data.img">
        </span>
        <span v-else class="children-img" style="margin-right: 16px">
          <img :src="data.img">
        </span> 
        <span>{{ node.label}}</span>          
      </span>
    </el-tree>
  </div>
</template>

<script>
export default {
  props: {
    departmentId: {
      type: Number
    },
    companyList: {
      type: Array
    },
    isSwitchImg: {
      type: Boolean,
      default: true
    },
    /* 是否启用搜索 */
    isSearch: {
      type: Boolean,
      default: true
    },
    /* 是选择部门还是选择人 */
    selectDepartment: {
      type: Boolean,
      default: true
    },
    firstImg: {
      type: String,
      default: require('../assets/tree/first.png')
    },
    firstHighImg: {
      type: String,
      default: require('../assets/tree/first-high.png')
    },
    secondImg: {
      type: String,
      default: require('../assets/tree/second.png')
    },
    secondHighImg: {
      type: String,
      default: require('../assets/tree/second-high.png')
    },
    threeSpotImg: {
      type: String,
      default: require('../assets/tree/three-spot.png')
    },
    threeSpotHighImg: {
      type: String,
      default: require('../assets/tree/three-spot-high.png')
    },
    bookImg: {
      type: String,
      default: require('../assets/tree/book.png')
    },
    randomImg: {
      type: String,
      default: require('../assets/tree/random.png')
    }
  },

  data() {
    return {
      defaultProps: {
        children: "subList",
        label: "departmentName"
      },
      filterText: '',
      id: this.departmentId
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  created() {
    this.companyList.map(i => {
      this.getLeafKeys(i)
    })
    this.mapId(this.companyList, this.id)
  },
  mounted() {
    this.$bus.on('clearSelect', v => {
      this.filterText = '',
      this.id = v
      this.$refs.tree.setCheckedKeys([this.id]);
      this.changeTreeNodeStatus(this.$refs.tree.store.root)
    })

    this.$bus.on('hignSelect', v => {
      this.id = v
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([this.id]);
        this.hignTreeNodeStatus(this.$refs.tree.store.root)
      })
    })
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.departmentName.indexOf(value) !== -1;
    },
    
    /* 点击变更部门 */
    handleNodeClick(data) {
      this.id = Number(data.id);
      this.mapId(this.companyList, data.id)
    },

    mapId(child, id) {
      child.map(i => {
        if (i.id === id) {
          if (i.level === 1) {
            i.img = this.isSwitchImg?this.firstHighImg:this.bookImg
          } else {
            i.img = this.isSwitchImg?this.secondHighImg:this.randomImg
          }
          i.threeSpotImg = this.threeSpotHighImg
        } else {
          if (i.level === 1) {
            i.img = this.isSwitchImg?this.firstImg:this.bookImg
          } else {
            i.img = this.isSwitchImg?this.secondImg:this.randomImg
          }
          i.threeSpotImg = this.threeSpotImg
        }
        if (i.subList && i.subList.length > 0) {
          this.mapId(i.subList, id);
        }
      })
    },

    
    // 改变节点的状态
    changeTreeNodeStatus (node) {
      node.expanded = false
      node.checked = false
      for (let i = 0; i < node.childNodes.length; i++) {
        // 改变节点的自身expanded状态
        node.childNodes[i].expanded = false
        node.childNodes[i].checked = false
        // 遍历子节点
        if (node.childNodes[i].childNodes.length > 0) {
          this.changeTreeNodeStatus(node.childNodes[i])
        }
      }
    },
    
    /* 
      通过递归的形式，获取最后一级的id，
    */
    getLeafKeys(node) {
      /* 
        如果当前 node 节点不包含 children 属性，
        则是三级节点
       */
      if (this.selectDepartment) {
        if (node.zzdCode == undefined) {
          /* 除了最后一级所有节点disabled为true */
          node.disabled = true;
        }
      } else {
        if (node.level != 4) {
          /* 除了最后一级所有节点disabled为true */
          node.disabled = true;
        }
      }
      node.subList.forEach(item => this.getLeafKeys(item));
    },

    /* 高亮选中 */
    hignTreeNodeStatus(node) {
      node.checked = false
      for (let i = 0; i < node.childNodes.length; i++) {
        // 改变节点的自身checked状态
        node.childNodes[i].checked = false
        if (node.childNodes[i].data.zzdCode != undefined) {
          if (this.id == node.childNodes[i].data.id2) {
            node.childNodes[i].checked = true
          }
        }
        // 遍历子节点
        if (node.childNodes[i].childNodes.length > 0) {
          this.hignTreeNodeStatus(node.childNodes[i])
        }
      }
    },

    handleNodeCheck(item, node) {
      if (node === true) {
        this.id = item.id;
        this.$refs.tree.setCheckedKeys([item.id]);
        this.mapId(this.companyList, item.id)
        this.$emit('selectTreeNodeList', item)
      }
    },
  }
}
</script>

<style lang='scss'>
.tree-people {
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: $bg-ChangeDepartmentHighTree;
    color: $color-ChangeDepartmentHighTree;
  }
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner{
        display: inline-block;
    }
    .el-checkbox.is-disabled .el-checkbox__inner{
        display: none;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
    }
  }
  .el-tree-node__content {
    height: 40px;
    line-height: 40px;
    font-size: $fs-small-l;
    color: $color-grey;
  }
  .search {
    margin-bottom: 12px;
    .el-input__prefix, .el-input__suffix {
      top: 2px;
    }
  }
}
</style>